var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { PageService } from '~/utils/page.service';
import { Prop, Emit, Watch } from 'vue-property-decorator';
import { LegalCaseManageService } from '~/services/domain-service/legal-case-manage.service';
import DistributionPattern from "~/components/distribution-common/distribution-pattern.vue";
var LegalConfirmDistribution = /** @class */ (function (_super) {
    __extends(LegalConfirmDistribution, _super);
    function LegalConfirmDistribution() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            distributeCategory: 'TO_COLLECTOR',
            commonFlag: 'YES',
            distributeMode: 'BY_CUSTOMIZE',
            distributeNumber: [],
        };
        _this.radio = '';
        _this.userDataSet = [];
        return _this;
    }
    LegalConfirmDistribution.prototype.refreshList = function () { };
    LegalConfirmDistribution.prototype.distributeModeChange = function (value) {
        var _this = this;
        this.legallyCaseManageServiceTestC.reviewDistributeCase(this.model).subscribe(function (data) {
            _this.userDataSet = data.resDistModel;
            _this.model.analyseId = data.analyseId;
        });
    };
    LegalConfirmDistribution.prototype.distributionDataChange = function (value) {
        var _this = this;
        if (!value)
            return;
        this.userDataSet = value.selectedUser;
        this.model.userIds = value.selectedUser.map(function (v) { return v.id; });
        this.model.caseIds = value.selectedCase.map(function (v) { return v.id; });
        this.legallyCaseManageServiceTestC.reviewDistributeCase(this.model).subscribe(function (data) {
            _this.userDataSet = data.resDistModel;
        });
    };
    LegalConfirmDistribution.prototype.refresh = function (distributionData, collectionType) {
        this.userDataSet = distributionData.userData;
        this.model.caseIds = distributionData.caseIds;
        this.model.collectionType = collectionType;
    };
    //取消
    LegalConfirmDistribution.prototype.cancle = function () {
        //close
    };
    //上一步
    LegalConfirmDistribution.prototype.back = function () { };
    //重置分配方式
    LegalConfirmDistribution.prototype.reset = function () {
        this.model.distributeMode = 'BY_CUSTOMIZE';
    };
    //下一步
    LegalConfirmDistribution.prototype.next = function () {
        var _this = this;
        this.model.outsourceIds = this.userDataSet.map(function (v) { return v.id; });
        this.model.distributeNumber = this.userDataSet.map(function (v) { return parseInt(v.num); });
        this.legallyCaseManageServiceTestC.confirmDistributeCase(this.model).subscribe(function (data) {
            _this.$message.success('分配成功');
            _this.cancle();
            _this.refreshList();
        });
    };
    /**
     * 输入框最大值
     */
    LegalConfirmDistribution.prototype.inputMax = function () {
        var max = this.model.caseIds.length;
        return max;
    };
    __decorate([
        Dependencies(PageService)
    ], LegalConfirmDistribution.prototype, "pageService", void 0);
    __decorate([
        Dependencies(LegalCaseManageService)
    ], LegalConfirmDistribution.prototype, "legallyCaseManageServiceTestC", void 0);
    __decorate([
        Prop({ required: true })
    ], LegalConfirmDistribution.prototype, "distributionData", void 0);
    __decorate([
        Prop({ required: false, type: Boolean })
    ], LegalConfirmDistribution.prototype, "again", void 0);
    __decorate([
        Emit('refreshList')
    ], LegalConfirmDistribution.prototype, "refreshList", null);
    __decorate([
        Watch('model.distributeMode')
    ], LegalConfirmDistribution.prototype, "distributeModeChange", null);
    __decorate([
        Watch('distributionData', { immediate: true })
    ], LegalConfirmDistribution.prototype, "distributionDataChange", null);
    __decorate([
        Emit('close')
    ], LegalConfirmDistribution.prototype, "cancle", null);
    __decorate([
        Emit('back')
    ], LegalConfirmDistribution.prototype, "back", null);
    LegalConfirmDistribution = __decorate([
        Component({
            components: {
                DistributionPattern: DistributionPattern
            },
        })
    ], LegalConfirmDistribution);
    return LegalConfirmDistribution;
}(Vue));
export default LegalConfirmDistribution;
